"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountButtonClick = void 0;
const enums_1 = require("../enums");
const trackAnalyticsEvent_1 = require("./trackAnalyticsEvent");
function trackCustomerAccountButtonClick(clickElement, clickText) {
    (0, trackAnalyticsEvent_1.trackAnalyticsEvent)({
        eventData: {
            eventName: enums_1.GA4EventName.ClickButton,
            feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
            click_element: clickElement,
            click_text: clickText,
        },
    });
}
exports.trackCustomerAccountButtonClick = trackCustomerAccountButtonClick;
//# sourceMappingURL=trackCustomerAccountButtonClick.js.map